import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Main Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Home',
    props: ['request','context_pg'],
    data () {
        return {
            searches: {},
            search: {},
            cnpros: {},
            cnpro: {},
            businesses:[],
            cnsurveys: {},
            forums: {},
            reviews: {},
            img_url: service.imageURL,
            cnproParentCategories:{},
            sub_categories:{},
            user:"",
            subscription:{},
            process_message:"",
        }
    },
    components: {
        'main-header': MainHeader,
        'main-footer': MainFooter
    },
    methods: {
    /* pre searchers */
    getCnproParentCategories() {
        service.getCnproParentCategories(this).then(data => {
            if(data.body.status == 200) {
                this.cnproParentCategories = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    //cnpro sub categories
    getCnproSubCategories(parent){
        service.getCnproCategories(this,parent).then(data => {
            if(data.body.status == 200) {
                this.sub_categories = data.body.data;
               // document.getElementById("loader").style.visibility = "hidden";
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    //businesses
    getBusinessCategories() {
        service.getBusinessCategories(this).then(data => {
            if(data.body.status == 200) {
                this.sub_categories = data.body.data;
            }
        }).catch((err) => {
            if(err) {
               // toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },
    prep_sub_categories(parent){
        if(parent == "business-search"){
            this.search.type = 'business-search';
            this.getBusinessCategories()
        }
        else{
            this.search.type = 'cnpro-search';
            this.getCnproSubCategories(parent)
        }
    },
    prep_search(keywords){
        this.search.keywords = keywords
        this.search.city = 'Abuja'
    },
    /* pre searchers */
    doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type+'?context='+this.search.keywords+'&city='+this.search.city);
                if(credentials.search_type == "businesses") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    //navi.push("business-search");
                    
                }
                else if(credentials.search_type == "cnpros") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                   // navi.push("cnpro-search");
                }
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
    },

    //search cnpro by category
    doSearch2(category){
        let navi = this.$router;
        localStorage.setItem("cityneeds_search_type", 'cnpros');
        localStorage.setItem("cityneeds_search_keywords", category);
        localStorage.setItem("cityneeds_search_city", 'Abuja');
        navi.push("cnpro-search");
           
    },
    
    //cnpros
    viewCnpro(cnpro){
        if(cnpro) {
            localStorage.setItem("cityneeds_search_cnpro", cnpro.cnpro_data_item); //use local storage for now
            this.$router.push("cnpro");
        }
        
    },
    getCnpros() {
        service.getAllCnpros(this).then(data => {
            if(data.body.status == 200) {
                this.cnpros = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //businesses
    viewBusiness(business){
        if(business) {
            localStorage.setItem("cityneeds_search_business", business.business_data_item); //use local storage for now
            this.$router.push("businesses");
        }
        
    },
    getBusinesses() {
        service.getAllBusinesses(this).then(data => {
            if(data.body.status == 200) {
                //this.businesses = data.body.data;
                //limi to 6
                let length = 0;
                let datan = data.body.data;
                datan.forEach(function(element) {
                    if(length <= 5){
                        this.businesses.push(element);
                    }
                    length++;  
                }, this);
                
                  
                
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //forums
    getForums() {
        service.getAllForums(this).then(data => {
            if(data.body.status == 200) {
                this.forums = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //reviews
    getReviews() {
        service.getAllReviews(this).then(data => {
            if(data.body.status == 200) {
                this.reviews = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                 //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    //surveys
    getSurveys() {
        let offset = 0; let items = 1;
        service.getAllSurveys(this,offset,items).then((res) => {
            this.cnsurveys = res.body.data;
        })
    },

    subscribe(){
        if((this.subscription.email == '') || (this.subscription.email == undefined)){
            this.process_message = "Please provide your email";
        }else{
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.subscription.email).toLowerCase());
            if((email_test == false)){
                this.process_message = "Please provide a valid email";
            }else{
                var payload = {
                    subscription_email: this.subscription.email,
                }
                service.subscribe(this,payload).then(data => {
                    if(data.body.status == 201) {
                        this.process_message = "Your subscription was successful";
                        this.subscription.email = '';
                        let self = this;
                        setTimeout(function (){
                            self.process_message = "";
                        }, 1000);
                    }
                }).catch((err) => {
                    if(err) {
                         //toastr.error('Sorry, could not process information', 'Warning!');
                         this.process_message = "Sorry, could not process information";
                    }
                })
            }
        }
    }
},
created: function(){

    if(this.$route.params.ref){
        localStorage.setItem("cityneeds_ref", this.$route.params.ref);
        this.$router.push("/");
    }
    let u = localStorage.getItem("cityneeds_user");
        if(u != null) {
           this.user = u;
        }
    setTimeout(function (){
        $('#prompt').modal();
    }, 4000);

    //control showing
    // $(document).ready(function() {
    //     if ($cookie('modal_shown') == null) {
    //         $cookie('modal_shown', 'yes', { expires: 7, path: '/' });
    //         // $('#myModal').reveal();
    //         setTimeout(function (){
    //             $('#prompt').reveal();
    //         }, 4000);
    //     }
    // });

    this.getSurveys();
    this.getCnpros();
    this.getBusinesses();
    this.getForums();
    this.getReviews();
    this.getCnproParentCategories();

    //remove some setts
    localStorage.removeItem("cityneeds_call_src");

}
}


// WEBPACK FOOTER //
// ./src/components/Home/script.js